
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      const open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});

document.addEventListener('keydown', (event) => {
 if (event.key === 'Escape') {
  document.querySelectorAll('.nav-dropdown[open]').forEach(el => { el.open = false; });
  document.querySelector('.main-nav')?.classList.remove('open');
  document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
 }
});
document.addEventListener('change', (event) => {
 if (event.target.id !== 'VariantSelect') return;
 const section = event.target.closest('section');
 const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
 const variant = variants.find(v => String(v.id) === event.target.value);
 if (!variant) return;
 const button = section.querySelector('.product-add');
 button.disabled = !variant.available;
 button.textContent = variant.available ? 'Add to cart' : 'Sold out';
 section.querySelector('[data-product-price]').textContent = event.target.selectedOptions[0].dataset.price;
 const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
});
